import { successToast } from 'components/toasts/success';
import { useMainProviderContext } from 'context/main/provider';

import { useApproveQuoteItemsMutation } from 'queries/approveOrder/approveQuoteItemsMutation';
import React, { useEffect, useRef, useState } from 'react';
import { CALENDAR_VIEW } from 'types';
import { MediaGalleryItem } from './MediaGalleryItem';
import { PlaybackDataVideoPlayer } from './PlaybackDataVideoPlayer';
import { AutomotiveItems } from './AutomotiveItems';
import { SchedulingViews } from './SchedulingViews';
import { QuoteItem } from 'queries/approveOrder/types';
import { LandingPageContentContainer } from './styles';
import { ContactInfoModal } from 'components/modals/ContactInfoModal';
import { ModalVideoCTA } from 'components/modals/ModalVideoCTA';

export const BodyLanding = () => {
  const { mutateAsync: approveQuoteItemsMutation } =
    useApproveQuoteItemsMutation();

  const { response, setResponse } = useMainProviderContext();

  const { interactiveCTAs, inventoryItem, landingPageDesign } = response;
  const { bodyBackgroundColor, bodyBackgroundImage, gradient, showGradient } =
    landingPageDesign;
  const videoRef = useRef<HTMLVideoElement>();
  const [quoteItemUpdated, setQuoteItemUpdated] = useState(false);

  const [showContactInfoModal, setShowContactInfoModal] = useState(false);
  const [showCtaVideoModal, setShowCtaVideoModal] = useState('');

  const [view, setView] = useState(CALENDAR_VIEW.LANDING);
  const [areControlsShown, setAreControlsShown] = useState(true);

  useEffect(() => {
    return () => {
      if (videoRef && videoRef.current) {
        videoRef.current.onloadedmetadata = null;
      }
    };
  }, [videoRef.current]);

  const openShowContactInfoModal = () => {
    setShowContactInfoModal(true);
  };

  // approve items should be refactord and use formik
  const handleQuoteItemClick = (updatedQuoteItems: QuoteItem[]) => {
    // Refactor old code
    // It mutates response.repairOrder directly, which breaks React state immutability principles
    // It spreads repairOrder into a new object, but only after mutating it.
    /*   const repairOrder = playbackData?.repairOrder;
      if (!repairOrder) {
        return;
      }
      repairOrder.quoteItems = [...updatedQuoteItems];
      playbackData.repairOrder = { ...repairOrder };
      setPlaybackData(playbackData); */
    setResponse(prev => {
      if (!prev?.repairOrder) return prev;

      return {
        ...prev,
        repairOrder: {
          ...prev.repairOrder,
          quoteItems: [...updatedQuoteItems],
        },
      };
    });

    setQuoteItemUpdated(true);
  };

  // approve items should be refactord and use formik
  const approveQuoteItems = async () => {
    const repairOrder = response?.repairOrder;
    if (!quoteItemUpdated || !response || !repairOrder) {
      return;
    }

    // check can we invalidate query
    const approvedRepairOrder = approveQuoteItemsMutation({
      data: { quoteItems: repairOrder.quoteItems || [] },
    });

    setResponse({
      ...response,
      repairOrder: { ...response.repairOrder, ...approvedRepairOrder },
    });

    setQuoteItemUpdated(false);

    successToast({
      title: 'Quote successfully updated!',
    });
  };

  const bodyOrientation = response.landingPageDesign.bodyOrientation;

  return (
    <>
      {view === CALENDAR_VIEW.LANDING && (
        <LandingPageContentContainer
          bodyBackgroundImage={bodyBackgroundImage}
          showGradient={showGradient}
          gradient={gradient}
          backgroundColor={bodyBackgroundColor}
          bodyOrientation={bodyOrientation}
        >
          <MediaGalleryItem
            designOverride={false}
            videoRef={videoRef}
            showContactInfoModal={showContactInfoModal}
            openShowContactInfoModal={openShowContactInfoModal}
            areControlsShown={areControlsShown}
          />

          {!inventoryItem && (
            <PlaybackDataVideoPlayer
              videoRef={videoRef}
              setAreControlsShown={setAreControlsShown}
              showContactInfoModal={showContactInfoModal}
              openShowContactInfoModal={openShowContactInfoModal}
              areControlsShown={areControlsShown}
            />
          )}
          <AutomotiveItems
            approveQuoteItems={approveQuoteItems}
            handleQuoteItemClick={handleQuoteItemClick}
            quoteItemUpdated={quoteItemUpdated}
            onChangeView={setView}
          />
        </LandingPageContentContainer>
      )}

      <SchedulingViews
        view={view}
        setView={setView}
        setPlaybackData={setResponse as any}
      />

      {showContactInfoModal && (
        <ContactInfoModal
          handleCloseModal={() => setShowContactInfoModal(false)}
          interactiveCTAs={interactiveCTAs.map(item => ({
            ...item,
            value: item.linkValue,
            label: item.title,
          }))}
          setShowCtaVideoModal={setShowCtaVideoModal}
        />
      )}

      {showCtaVideoModal !== '' && (
        <ModalVideoCTA
          handleCloseModal={() => setShowCtaVideoModal('')}
          videoSource={showCtaVideoModal}
        />
      )}
    </>
  );
};
